export default "__VITE_ASSET__DTj$50n3__"